import { ProyectoProvider } from "./contextoProyecto";
import ProyectosCV from "./controladorVista/proyectosCV"

export const Proyectos = () => {
    return (
        // <ProveedorCargando>
            <ProyectoProvider >
                <ProyectosCV />
            </ProyectoProvider >
        //  </ProveedorCargando>
    );
}